module.exports = __webpack_public_path__ + "img/banner03-mobile.142d682c.webp";